export const convertToLeagueMatchFormat = (data) => {
  const filteredLeagues = data.reduce((leagues, currentMatch) => {
    if (!currentMatch) {
      return leagues;
    }

    const { league, ...restMatch } = currentMatch;

    const leagueId = league?.id;
    if (!leagueId) {
      return leagues;
    }

    if (!leagues[leagueId]) {
      leagues[leagueId] = {
        ...league,
        matches: [currentMatch],
      };
    } else {
      leagues[leagueId].matches.push({
        league,
        ...restMatch,
      });
    }

    return leagues;
  }, {});

  return filteredLeagues ? Object.values(filteredLeagues) : [];
};
